import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "ls_theme";

function getInitial() {
  if (typeof window === "undefined") return "dark";
  const stored = localStorage.getItem(KEY);
  if (stored === "light" || stored === "dark") return stored;
  return "dark"; // default = brand
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      className="relative w-9 h-9 inline-flex items-center justify-center border border-[var(--border-c,#2E2E38)] text-[var(--fg,#F2F2F2)] hover:text-[#E3FF34] hover:border-[#E3FF34]/60 transition-colors overflow-hidden"
    >
      <Sun
        size={14}
        className={`absolute transition-all duration-500 ${
          theme === "dark"
            ? "opacity-0 -rotate-90 scale-50"
            : "opacity-100 rotate-0 scale-100"
        }`}
      />
      <Moon
        size={14}
        className={`absolute transition-all duration-500 ${
          theme === "dark"
            ? "opacity-100 rotate-0 scale-100"
            : "opacity-0 rotate-90 scale-50"
        }`}
      />
    </button>
  );
}
